<div *ngIf="config.active">
  <div
    class="chatbot-container"
    [ngStyle]="{
      border: '1px solid ' + configs?.colors?.bot_message_border,
      background: configs?.colors?.bot_message_background
    }"
  >
    <p
      *ngIf="messageText"
      [ngStyle]="{
        'font-family': configs?.fonts?.default_font,
        'font-size': configs?.fonts?.default_font_size_px + 'px' || '16px',
        color: configs?.colors?.bot_message_text
      }"
      [innerHTML]="messageText"
    ></p>
    <mat-chip-set class="chipset-cutom">
      <mat-chip
        *ngFor="let pill of config.button_items"
        (click)="onPillClick(pill)"
        [disabled]="!config.active"
        class="custom-chip"
        [ngStyle]="{
        'font-family': configs?.fonts?.default_font,
        'font-size': configs?.fonts?.default_font_size_px + 'px' || '16px',
        'background-color': configs?.colors?.bot_message_button_background,
        cursor: 'pointer',
        color: configs?.colors?.bot_message_text,
      }"
      >
        {{ pill.label }}
      </mat-chip>
    </mat-chip-set>
  </div>
  <div class="display-flex flex-space-between" style="width: 100%">
    <app-message-timestamp
      *ngIf="input.created_at && input.created_at > 0"
      [createdAt]="input.created_at"
    >
    </app-message-timestamp>
    <span
      class="unread"
      *ngIf="!isRead"
      [ngStyle]="{
                'color': configs?.colors?.user_message_background,
              }"
      >{{ messageUnreadText }}</span
    >
  </div>
</div>
<div class="chatbot-container" *ngIf="!config.active">
  <p>{{ inactiveMessage }}</p>
</div>
